import { RcClasses } from '../../../../foundation';
export var RcSnackbarActionClasses = RcClasses(['text', 'icon'], 'RcSnackbarAction');
